<template>
  <div class="ss-container" :style="backgroundColor">
    <div class="container">
      <div class="row flex-row">
        <div class="col-xs-12 col-sm-6 text-left">
          <h1 class="ss-header">
            SCHEDULE YOUR SERVICE
          </h1>
          <h2 class="ss-subheader">
            ONLINE RIGHT HERE, RIGHT NOW!
          </h2>
        </div>
        <div class="col-xs-12 col-sm-6">
          <a href="#" class="btn btn-block ss-btn" :style="buttonColor">MAKE AN APPOINTMENT</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    ...mapGetters(["brandData"]),
    buttonColor () {
      if (this.brand === 'none') {
        return {'background-color': '#cc0000', 'color': '#fff'};
      } else if (this.brand === 'toyota' || this.brand === 'nissan' || this.brand === 'mitsubishi' || this.brand === 'honda' || this.brand === 'chevrolet' || this.brand === 'ford' || this.brand === 'hyundai'  || this.brand === 'lincoln') {
        return {'background-color': 'var(--primary-color)', 'color': '#fff'};
      } else if (this.brand === 'cjdr') {
        return {'background-color': 'var(--secondary-color)', 'color': '#fff'};
      } else {
        return {'backgroundColor': 'var(--primary-light)', 'color': 'var(--primary-dark)', 'opacity': '.92'};
      }
    },
    backgroundColor () {
      if (this.brand === 'none') {
        return {'background-color': '#333'};
      } else if (this.brand === 'ford') {
        return {'background-color': 'var(--secondary-dark)'};
      } else {
        return {'backgroundColor': 'var(--primary-dark)'};
      }
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.ss-container .ss-btn:hover {
  color: white;
  filter: brightness(1.2);
  opacity: 1 !important;
}
.ss-container .ss-btn {
  font-size: 36px !important;
  color: #fff;
  padding: 6px 12px;
  background: var(--primary-color);;
  font-weight: bold;
  white-space: normal;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ss-container .flex-row {
  display: flex;
  flex-wrap: wrap;
}
.ss-container {
  background-color: #2c2c2c;
  color: white;
  overflow: auto;
}
.ss-container .ss-header, .ss-container h2.ss-subheader {
  margin-top: 0px;
}
@media (max-width: 767px) {
  .ss-container .ss-btn {
    font-size: 24px !important;
  }
  .ss-container .ss-header,
  .ss-container .ss-subheader {
    text-align: center;
  }
  .ss-header {
    font-size: 25px;
  }
  .ss-container .ss-subheader {
    font-size: 13px;
  }
}
@media (max-width: 420px) {
  .ss-container .ss-btn {
    font-size: 20px !important;
  }
}
</style>
